/**
 * Modelli pronti del builder: la struttura di una mail tipo, con testi brevi che dicono il
 * ruolo di ogni pezzo. Si riempiono a mano o con l'assistente ("Adatta la mail al mio brand").
 *
 * Ogni modello e' una lista di insert nello stesso formato dell'assistente e passa da
 * applyActions (aiContract.js): stessi controlli, e un campo di testo non scritto qui resta
 * vuoto invece di portarsi dietro il segnaposto del catalogo.
 */

var HEADING = 'margin:0 0 6px 0;font-family:Arial,Helvetica,sans-serif;font-size:18px;font-weight:700;color:#222222;text-align:center;'
var PARAGRAPH = 'margin:0;font-family:Arial,Helvetica,sans-serif;font-size:15px;line-height:1.5;color:#555555;text-align:center;'

function insert(block) {
	return { op: 'insert', block: block }
}

function header() {
	return insert({ type: 'header', settings: { logoAlt: 'Logo' } })
}

// I dati legali restano vuoti: li mette l'assistente dal brand o chi compone, e finche'
// mancano il builder lo segnala (legalGaps). Un "Ragione sociale" di esempio passerebbe il controllo
function footer() {
	return insert({
		type: 'footer-full',
		settings: {
			reasonText: 'Ricevi questa email perché sei iscritto alla nostra newsletter.',
			unsubscribeText: 'Non vuoi più ricevere queste email?'
		}
	})
}

function infoColumn(title, text) {
	return {
		type: 'heading',
		content: '<h3 style="' + HEADING + '">' + title + '</h3><p style="' + PARAGRAPH + '">' + text + '</p>'
	}
}

function product(name, badge) {
	return { name: name, badge: badge || '', price: '€ 00,00', buttonText: 'Acquista' }
}

export var emailModels = [
	{
		key: 'newsletter',
		label: 'Newsletter',
		icon: 'mdi-newspaper-variant-outline',
		description: 'Notizia principale, due articoli, un invito e il footer',
		actions: [
			header(),
			insert({
				type: 'hero',
				settings: {
					layout: 'standard',
					eyebrow: 'Le novità del mese',
					title: 'La notizia principale',
					text: 'Una o due frasi che presentano la novità più importante.',
					buttonText: 'Scopri di più'
				}
			}),
			insert({
				type: 'article',
				settings: {
					imagePosition: 'left',
					title: 'Seconda notizia',
					text: 'Due o tre frasi che la raccontano e rimandano al sito.',
					linkText: 'Leggi tutto'
				}
			}),
			insert({
				type: 'article',
				settings: {
					imagePosition: 'right',
					title: 'Terza notizia',
					text: 'Due o tre frasi che la raccontano e rimandano al sito.',
					linkText: 'Leggi tutto'
				}
			}),
			insert({
				type: 'banner',
				settings: {
					title: 'Un appuntamento da non perdere',
					text: 'Una riga sull\'evento o sull\'offerta del mese.',
					buttonText: 'Partecipa'
				}
			}),
			footer()
		]
	},
	{
		key: 'promozione',
		label: 'Promozione',
		icon: 'mdi-tag-outline',
		description: 'Offerta in grande, griglia di prodotti, condizioni e il footer',
		actions: [
			header(),
			insert({
				type: 'hero',
				settings: {
					layout: 'overlay',
					eyebrow: 'Solo per pochi giorni',
					title: '-20% su tutta la collezione',
					text: 'Usa il codice SCONTO20 entro domenica.',
					buttonText: 'Approfitta ora'
				},
				// Il testo sta sopra la foto: il fondo scuro regge anche quando l'immagine non si carica
				styles: { 'background-color': '#222222', color: '#ffffff' },
				titleStyles: { color: '#ffffff', 'font-size': '40px', 'font-weight': '700', 'line-height': '1.15' }
			}),
			insert({
				type: 'products',
				settings: {
					columns: '2',
					items: [product('Primo prodotto', 'Novità'), product('Secondo prodotto'), product('Terzo prodotto'), product('Quarto prodotto', 'Ultimi pezzi')]
				}
			}),
			insert({
				type: 'banner',
				settings: {
					title: 'Spedizione gratuita',
					text: 'Su tutti gli ordini, fino alla fine della promozione.'
				}
			}),
			footer()
		]
	},
	{
		key: 'evento',
		label: 'Evento / lancio',
		icon: 'mdi-calendar-star',
		description: 'Annuncio, quando e dove, il programma, l\'invito a prenotare e il footer',
		actions: [
			header(),
			insert({
				type: 'hero',
				settings: {
					layout: 'standard',
					eyebrow: 'Save the date',
					title: 'Il nome dell\'evento',
					text: 'Una frase che dice cos\'è e perché non mancare.',
					buttonText: 'Prenota il posto'
				}
			}),
			insert({
				type: 'section-3col',
				columns: [
					{ children: [infoColumn('Quando', 'Giorno e ora')] },
					{ children: [infoColumn('Dove', 'Indirizzo o link della diretta')] },
					{ children: [infoColumn('Come partecipare', 'Ingresso libero su prenotazione')] }
				]
			}),
			insert({
				type: 'article',
				settings: {
					imagePosition: 'left',
					title: 'Il programma',
					text: 'Due o tre righe su cosa succede e chi ci sarà.',
					linkText: 'Tutti i dettagli'
				}
			}),
			insert({
				type: 'banner',
				settings: {
					title: 'I posti sono limitati',
					text: 'Prenota adesso per essere sicuro di esserci.',
					buttonText: 'Prenota ora'
				}
			}),
			footer()
		]
	}
]

/** Chip che segue l'applicazione di un modello: e' anche il testo che parte all'assistente */
export var ADAPT_MODEL_PROMPT = 'Adatta la mail al mio brand: testi, foto, logo e footer'

export function findModel(key) {
	for (var i = 0; i < emailModels.length; i++) {
		if (emailModels[i].key === key) return emailModels[i]
	}
	return null
}
